import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import IDCardDashboard from '../IDCardDashboard';

const ShowcaseIDCard = ({ showcaseData, limitToFirst = false }) => {
  if (!showcaseData) {
    return (
      <div className="text-center py-20">
        <p className="text-white/60">Lade Showcase...</p>
      </div>
    );
  }

  // Wandle Showcase-Daten in IDCardDashboard-Format um
  const mockUser = {
    id: showcaseData.user.id,
    name: showcaseData.user.name,
    email: "julia@snapshotpro.ai",
    profile_image_url: showcaseData.avatar.profile_image_url || showcaseData.user.profile_image_url  // Avatar-Bild oder Fallback
  };

  return (
    <IDCardDashboard 
      currentUser={mockUser}
      readOnlyMode={true}
      showcaseData={showcaseData}
      limitToFirst={limitToFirst}
      onStartCreation={() => {}}
      onBackToDashboard={() => {}}
      onLogout={() => {}}
    />
  );
};

export default ShowcaseIDCard;
